import React from "react";
import Contexto from "./Contexto";


export default function UsarContexto(props) {
    const {children} = props;
  return <Contexto.Provider
  value={{
    
  }}
>
  {children}
</Contexto.Provider>;
}
